import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import {
  addNewTaskPriority,
  addNewTaskPrioritySuccess,
  addNewTaskStatus,
  addNewTaskStatusSuccess,
  addNewTaskType,
  addNewTaskTypeSuccess,
  deleteTaskPriority,
  deleteTaskPrioritySuccess,
  deleteTaskStatus,
  deleteTaskStatusSuccess,
  deleteTaskType,
  deleteTaskTypeSuccess,
  getTaskPriorityList,
  getTaskStatusListCrmIT,
  getTaskTypeList,
  updateTaskPriority,
  updateTaskPrioritySuccess,
  updateTaskStatus,
  updateTaskStatusSuccess,
  updateTaskType,
  updateTaskTypeSuccess,
} from "../../../../store/tasksCrmIT/action";
import { updateLocalSettingsMasterConfigToggle } from "../../../../store/generalSettings/action";
import TaskTemplate from "./taskTemplate";
// Change #100261 - named lists of tasks, applied to a job in one go.
import TaskListTemplate from "./taskListTemplate";

// MasterConfigItem.Id for the task-status sort mode flag (ZCONFIGVAL_55_X):
// '1' = A-Z by name, anything else = custom drag order. See
// 20260906_TaskStatusSortMode_MasterConfig.sql.
const TASK_STATUS_SORT_MODE_CONFIG_ID = 55;

const readSortModeIsAZ = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    return String(authUser?.get_configitem_data?.ZCONFIGVAL_55_X) === "1";
  } catch (e) {
    return false;
  }
};
export default function TaskSettings() {
  const dispatch = useDispatch();
  const { taskPriorityList, taskTypeList, tasksCrmITStatusListApi } =
    useSelector((state) => ({
      taskPriorityList: state.TasksCrmIt.taskPriorityList?.taskpriority_list,
      taskTypeList: state.TasksCrmIt.taskTypeList?.tasktype_list,
      tasksCrmITStatusListApi:
        state.TasksCrmIt.taskStatusListCrmIT?.taskstatus_list,
    }));
  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  // Task-status sort mode toggle (company flag). true = A-Z, false = custom.
  const [statusSortIsAZ, setStatusSortIsAZ] = useState(readSortModeIsAZ());
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: "0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(addNewTaskStatus([createStatus]));
    }
    if (activeTab === "2") {
      // Task Type create
      dispatch(addNewTaskType([createStatus]));
    }
    if (activeTab === "3") {
      // Task Priority create
      dispatch(addNewTaskPriority([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      // Statuses: honour the sort mode. A-Z sorts by Name; custom sorts by the
      // `Order` column (Name as tie-break) so drag order is reflected here too.
      data = [...(tasksCrmITStatusListApi || [])].sort((a, b) => {
        if (statusSortIsAZ) {
          return (a?.Name || "").localeCompare(b?.Name || "");
        }
        const ao = Number(a?.Order) || 0;
        const bo = Number(b?.Order) || 0;
        if (ao !== bo) return ao - bo;
        return (a?.Name || "").localeCompare(b?.Name || "");
      });
      setStatusFlag(true);
    }
    if (activeTab === "2") {
      // Custom drag order: sort by the `Order` column (Id as tie-break).
      data = [...(taskTypeList || [])].sort((a, b) => {
        const ao = Number(a?.Order) || 0;
        const bo = Number(b?.Order) || 0;
        if (ao !== bo) return ao - bo;
        return (Number(a?.Id) || 0) - (Number(b?.Id) || 0);
      });
      setStatusFlag(false);
    }
    if (activeTab === "3") {
      data = [...(taskPriorityList || [])].sort((a, b) => {
        const ao = Number(a?.Order) || 0;
        const bo = Number(b?.Order) || 0;
        if (ao !== bo) return ao - bo;
        return (Number(a?.Id) || 0) - (Number(b?.Id) || 0);
      });
      setStatusFlag(false);
    }
    if (activeTab === "4") {
      data = [];
      setStatusFlag(false);
    }
    setStatusList(data);
  }, [
    tasksCrmITStatusListApi,
    taskTypeList,
    taskPriorityList,
    activeTab,
    statusSortIsAZ,
  ]);

  useEffect(() => {
    dispatch(getTaskStatusListCrmIT());
    dispatch(getTaskPriorityList());
    dispatch(getTaskTypeList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete

      dispatch(deleteTaskStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      // Task Type delete
      dispatch(deleteTaskType([deleteStatus]));
    }
    if (activeTab === "3") {
      // Task Priority delete
      dispatch(deleteTaskPriority([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
      FlagComplete: updateItemStatus?.FlagComplete,
      Order: updateItemStatus?.Order,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update

        dispatch(updateTaskStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        // Task Type update
        dispatch(updateTaskType([updateNewStatus]));
      }
      if (activeTab === "3") {
        // Task Priority update
        dispatch(updateTaskPriority([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    addNewTaskStatusSuccessAPI,
    updateTaskStatusSuccessAPI,
    deleteTaskStatusSuccessAPI,
  } = useSelector((state) => ({
    addNewTaskStatusSuccessAPI: state.TasksCrmIt.addNewTaskStatusSuccess,
    updateTaskStatusSuccessAPI: state.TasksCrmIt.updateTaskStatusSuccess,
    deleteTaskStatusSuccessAPI: state.TasksCrmIt.deleteTaskStatusSuccess,
  }));

  // Add New Task Status response
  useEffect(() => {
    if (isEmpty(addNewTaskStatusSuccessAPI)) return;
    if (addNewTaskStatusSuccessAPI?.status === 200) {
      toast.success(addNewTaskStatusSuccessAPI?.message);
      dispatch(getTaskStatusListCrmIT());
    } else {
      toast.error(addNewTaskStatusSuccessAPI?.message);
    }
    dispatch(addNewTaskStatusSuccess([]));
  }, [addNewTaskStatusSuccessAPI]);
  // Update Task Status response
  useEffect(() => {
    if (isEmpty(updateTaskStatusSuccessAPI)) return;
    if (updateTaskStatusSuccessAPI?.status === 200) {
      toast.success(updateTaskStatusSuccessAPI?.message);
      dispatch(getTaskStatusListCrmIT());
    } else {
      toast.error(updateTaskStatusSuccessAPI?.message);
    }
    dispatch(updateTaskStatusSuccess([]));
  }, [updateTaskStatusSuccessAPI]);
  // Delete Task Status response
  useEffect(() => {
    if (isEmpty(deleteTaskStatusSuccessAPI)) return;
    if (deleteTaskStatusSuccessAPI?.status === 200) {
      toast.success(deleteTaskStatusSuccessAPI?.message);
      dispatch(getTaskStatusListCrmIT());
      setDeleteModal(false);
    } else {
      toast.error(deleteTaskStatusSuccessAPI?.message);
    }
    dispatch(deleteTaskStatusSuccess([]));
  }, [deleteTaskStatusSuccessAPI]);

  // Add New Task Type response
  const {
    addNewTaskTypeSuccessAPI,
    updateTaskTypeSuccessAPI,
    deleteTaskTypeSuccessAPI,
  } = useSelector((state) => ({
    addNewTaskTypeSuccessAPI: state.TasksCrmIt.addNewTaskTypeSuccess,
    updateTaskTypeSuccessAPI: state.TasksCrmIt.updateTaskTypeSuccess,
    deleteTaskTypeSuccessAPI: state.TasksCrmIt.deleteTaskTypeSuccess,
  }));

  // Add New Task Type response
  useEffect(() => {
    if (isEmpty(addNewTaskTypeSuccessAPI)) return;
    if (addNewTaskTypeSuccessAPI?.status === 200) {
      toast.success(addNewTaskTypeSuccessAPI?.message);
      dispatch(getTaskTypeList());
    } else {
      toast.error(addNewTaskTypeSuccessAPI?.message);
    }
    dispatch(addNewTaskTypeSuccess([]));
  }, [addNewTaskTypeSuccessAPI]);
  // Update Task Type response
  useEffect(() => {
    if (isEmpty(updateTaskTypeSuccessAPI)) return;
    if (updateTaskTypeSuccessAPI?.status === 200) {
      toast.success(updateTaskTypeSuccessAPI?.message);
      dispatch(getTaskTypeList());
    } else {
      toast.error(updateTaskTypeSuccessAPI?.message);
    }
    dispatch(updateTaskTypeSuccess([]));
  }, [updateTaskTypeSuccessAPI]);
  // Delete Task Type response
  useEffect(() => {
    if (isEmpty(deleteTaskTypeSuccessAPI)) return;
    if (deleteTaskTypeSuccessAPI?.status === 200) {
      toast.success(deleteTaskTypeSuccessAPI?.message);
      dispatch(getTaskTypeList());
      setDeleteModal(false);
    } else {
      toast.error(deleteTaskTypeSuccessAPI?.message);
    }
    dispatch(deleteTaskTypeSuccess([]));
  }, [deleteTaskTypeSuccessAPI]);

  // Add New Task Priority response
  const {
    addNewTaskPrioritySuccessAPI,
    updateTaskPrioritySuccessAPI,
    deleteTaskPrioritySuccessAPI,
  } = useSelector((state) => ({
    addNewTaskPrioritySuccessAPI: state.TasksCrmIt.addNewTaskPrioritySuccess,
    updateTaskPrioritySuccessAPI: state.TasksCrmIt.updateTaskPrioritySuccess,
    deleteTaskPrioritySuccessAPI: state.TasksCrmIt.deleteTaskPrioritySuccess,
  }));

  // Add New Task Priority response
  useEffect(() => {
    if (isEmpty(addNewTaskPrioritySuccessAPI)) return;
    if (addNewTaskPrioritySuccessAPI?.status === 200) {
      toast.success(addNewTaskPrioritySuccessAPI?.message);
      dispatch(getTaskPriorityList());
    } else {
      toast.error(addNewTaskPrioritySuccessAPI?.message);
    }
    dispatch(addNewTaskPrioritySuccess([]));
  }, [addNewTaskPrioritySuccessAPI]);
  // Update Task Priority response
  useEffect(() => {
    if (isEmpty(updateTaskPrioritySuccessAPI)) return;
    if (updateTaskPrioritySuccessAPI?.status === 200) {
      toast.success(updateTaskPrioritySuccessAPI?.message);
      dispatch(getTaskPriorityList());
    } else {
      toast.error(updateTaskPrioritySuccessAPI?.message);
    }
    dispatch(updateTaskPrioritySuccess([]));
  }, [updateTaskPrioritySuccessAPI]);
  // Delete Task Priority response
  useEffect(() => {
    if (isEmpty(deleteTaskPrioritySuccessAPI)) return;
    if (deleteTaskPrioritySuccessAPI?.status === 200) {
      toast.success(deleteTaskPrioritySuccessAPI?.message);
      dispatch(getTaskPriorityList());
      setDeleteModal(false);
    } else {
      toast.error(deleteTaskPrioritySuccessAPI?.message);
    }
    dispatch(deleteTaskPrioritySuccess([]));
  }, [deleteTaskPrioritySuccessAPI]);

  // Persist a drag-reordered list. The shared StatusViewEditComponent has
  // already renumbered each row's `Order` and updated local state; here we just
  // dispatch the matching batch update (the controller loops the array), then
  // the list refreshes from the success handler. Which entity we hit depends on
  // the active tab (Status / Type / Priority all carry an `Order` column).
  const handleReorder = (reordered) => {
    const payload = reordered.map((s) => ({ Id: s.Id, Order: s.Order }));
    if (activeTab === "1") dispatch(updateTaskStatus(payload));
    if (activeTab === "2") dispatch(updateTaskType(payload));
    if (activeTab === "3") dispatch(updateTaskPriority(payload));
  };

  // Flip the company-wide sort mode (custom <-> A-Z). Persists the ZCONFIGVAL_55
  // company flag, patches localStorage so the toggle state survives without a
  // re-login, and refreshes the list so the new order shows immediately.
  const handleSortModeChange = (isAZ) => {
    if (isAZ === statusSortIsAZ) return;
    setStatusSortIsAZ(isAZ);
    const value = isAZ ? "1" : "0";
    dispatch(
      updateLocalSettingsMasterConfigToggle([
        {
          MasterConfigItem_Id: TASK_STATUS_SORT_MODE_CONFIG_ID,
          ConfigCompany_FlagAllowUserOverride: "0",
          ConfigCompany_Value: value,
        },
      ])
    );
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser")) || {};
      authUser.get_configitem_data = {
        ...(authUser.get_configitem_data || {}),
        ZCONFIGVAL_55_X: value,
      };
      localStorage.setItem("authUser", JSON.stringify(authUser));
    } catch (e) {
      /* localStorage unavailable - board still updates from the backend fetch */
    }
    setTimeout(() => dispatch(getTaskStatusListCrmIT()), 300);
  };

  const StatusOrderToolbar = (
    <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
      <span className="text-muted small">Order:</span>
      <div className="btn-group btn-group-sm" role="group">
        <button
          type="button"
          className={`btn ${
            !statusSortIsAZ ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => handleSortModeChange(false)}
        >
          <i className="ri-drag-move-2-line me-1" /> Custom
        </button>
        <button
          type="button"
          className={`btn ${
            statusSortIsAZ ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => handleSortModeChange(true)}
        >
          <i className="ri-sort-alphabet-asc me-1" /> A-Z
        </button>
      </div>
      <span className="text-muted small">
        {statusSortIsAZ
          ? "Alphabetical. Your custom order is kept and returns when you switch back."
          : "Drag rows by the grip to set your own order (used on the board and pickers)."}
      </span>
    </div>
  );

  const Tabs = [
    {
      id: "1",
      name: "Statuses",
      content: (
        <>
          {StatusOrderToolbar}
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
            statusFlag={statusFlag}
            reorderable={!statusSortIsAZ}
            onReorder={handleReorder}
          />
        </>
      ),
    },
    {
      id: "2",
      name: "Types",
      content: (
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          statusFlag={statusFlag}
          reorderable
          onReorder={handleReorder}
        />
      ),
    },
    {
      id: "3",
      name: "Priorities",
      content: (
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          statusFlag={statusFlag}
          reorderable
          onReorder={handleReorder}
        />
      ),
    },
    {
      id: "4",
      name: "Task Templates",
      content: <TaskTemplate />,
    },
    {
      id: "5",
      name: "Task List Templates",
      content: <TaskListTemplate />,
    },
  ];
  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Task Settings"
        description="Statuses, types, priorities and templates for tasks"
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <div className="tab-content">
          {Tabs.find((item) => item.id === activeTab)?.content}
        </div>
      </SettingsPanel>
    </>
  );
}
